<script lang="ts">
    import { clickOutside } from '../../helpers/event';
    import { fly } from 'svelte/transition';
    import WishlistInner from './WishlistInner.svelte';

    export let hide: Function;
</script>

<div
    class="wishList"
    use:clickOutside
    on:click_outside={hide}
    transition:fly={{ y: 200, duration: 300 }}
>
    <WishlistInner {hide} />
</div>

<style>
    .wishList {
        background-color: white;
        border: 1px solid #8080808c;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        border-radius: 10px;
        box-shadow: 0px 1px 1px rgb(0 0 0 / 25%), 0 5px 5px rgb(0 0 0 / 22%);
        padding: 10px 5px 3px 5px;
        min-width: 340px;
        margin-left: 55px;
    }
</style>
